import { peopleAuthPath } from "./apiRoutes";

function djangoPeopleAuthPath(relativeAuthPath: string): string {
  const p = relativeAuthPath.replace(/^\/+/, "").replace(/\/+$/, "");
  return `/api/v1.0/auth/${p}/`;
}

export function getPeopleApiBaseUrl(): string {
  const raw = import.meta.env.VITE_PEOPLE_API_URL;
  const trimmed = typeof raw === "string" ? raw.trim() : "";
  if (trimmed) return trimmed.replace(/\/+$/, "");
  return "";
}

/**
 * Base for auth requests. Empty string = same-origin (Vite proxy to People).
 */
export function getPeopleAuthRequestBase(): string {
  const devFlag = import.meta.env.DEV;
  let base = devFlag ? "" : getPeopleApiBaseUrl();

  if (typeof globalThis !== "undefined" && "window" in globalThis && base !== "") {
    const { hostname } = (globalThis as unknown as { window: Window }).window.location;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      base = "";
    }
  }

  return base;
}

export function peopleAuthUrl(relativeAuthPath: string): string {
  const base = getPeopleAuthRequestBase();
  const path =
    base === "" ? peopleAuthPath(relativeAuthPath) : djangoPeopleAuthPath(relativeAuthPath);
  if (base === "") return path;
  return `${base.replace(/\/+$/, "")}${path}`;
}

/**
 * URL for an authenticated People *core* API endpoint (not under `/auth/`),
 * e.g. the MFA routes at `/api/v1.0/mfa/...`. In dev this goes through the
 * `/api/people/*` passthrough proxy; in prod it hits the People base directly.
 */
export function peopleApiUrl(relativePath: string): string {
  const base = getPeopleAuthRequestBase();
  const p = relativePath.replace(/^\/+/, "").replace(/\/+$/, "");
  if (base === "") {
    return `/api/people/api/v1.0/${p}/`;
  }
  return `${base.replace(/\/+$/, "")}/api/v1.0/${p}/`;
}

function djangoPeopleInvitationPath(relativePath: string): string {
  const p = relativePath.replace(/^\/+/, "").replace(/\/+$/, "");
  return `/api/v1.0/invitations/${p}/`;
}

/**
 * URL for the public (unauthenticated) AdminInvitation validate/accept
 * endpoints. Not under `/api/auth/` — those two routes live at the People
 * API root (`/api/v1.0/invitations/...`), so dev goes through the
 * `/api/people/*` passthrough proxy (peopleApiRootDevProxy) rather than the
 * auth-specific rewrite peopleAuthUrl uses.
 */
export function peopleInvitationUrl(relativePath: string): string {
  const base = getPeopleAuthRequestBase();
  if (base === "") {
    const p = relativePath.replace(/^\/+/, "").replace(/\/+$/, "");
    return `/api/people/api/v1.0/invitations/${p}/`;
  }
  return `${base.replace(/\/+$/, "")}${djangoPeopleInvitationPath(relativePath)}`;
}
